import type { Theme } from '../../types/theme';

export const pinterestTheme: Theme = {
  id: 'pinterest',
  name: 'Pinterest',
  description: 'Red accent with masonry grid for visual discovery platform',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/pinterest/DESIGN.md',
  visualKeywords: ['red accent', 'masonry grid', 'image-first', 'visual', 'discovery'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#111111',
    textSecondary: '#757575',
    textMuted: '#757575',
    border: '#e0e0e0',
    borderSubtle: '#d6d6d6',
    primary: '#e60023',
    primaryHover: '#f50f32',
    primaryActive: '#c80005',
    accent: '#e60023',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'visual',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
